import React, { useState } from "react";
import { Link2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export const UrlImport = ({ projectId, onDone }) => {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const urls = text.split(/\s+/).filter((u) => /^https?:\/\//.test(u));

  const go = async () => {
    setBusy(true);
    try {
      const r = await api.importUrls(projectId, urls);
      toast.success(`${r.queued} download(s) queued — watch progress in the Job Queue`);
      setText(""); onDone && onDone();
    } catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
    finally { setBusy(false); }
  };

  return (
    <div className="studio-card p-4 space-y-3" data-testid="url-import">
      <div className="flex items-center gap-2"><Link2 size={16} className="text-[#00F0FF]" /><span className="font-semibold text-sm">Import from cloud links</span></div>
      <p className="text-[#64748B] text-xs">One link per line — Google Drive / Dropbox file or whole-folder links, OneDrive, Box, JioCloud (best effort) or any direct file URL (S3, server, CDN). Links must be shared publicly ("Anyone with the link"); folders are scanned and every video/audio clip inside is imported.</p>
      <textarea value={text} onChange={(e) => setText(e.target.value)} rows={3} data-testid="url-import-input"
        placeholder={"https://drive.google.com/file/d/…/view\nhttps://www.dropbox.com/s/…/ceremony_camA.mp4?dl=0"}
        className="studio-input font-mono text-xs w-full" />
      <div className="flex items-center justify-between">
        <span className="metric-label" data-testid="url-import-count">{urls.length} link(s)</span>
        <button className="btn btn-gold !py-1.5 text-sm" onClick={go} disabled={busy || !urls.length} data-testid="btn-import-urls">
          {busy ? <Loader2 size={14} className="animate-spin" /> : <Link2 size={14} />} Pull footage
        </button>
      </div>
    </div>
  );
};
